/**
 * Plays a short notification sound using the Web Audio API.
 * No external files needed — generates a pleasant two-tone chime.
 */
export function playOrderSound(type: "new" | "cancelled" = "new") {
  try {
    const ctx = new AudioContext();
    const now = ctx.currentTime;

    if (type === "new") {
      // Pleasant two-note ascending chime
      const freqs = [523.25, 659.25]; // C5 → E5
      freqs.forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = "sine";
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0, now + i * 0.15);
        gain.gain.linearRampToValueAtTime(0.15, now + i * 0.15 + 0.05);
        gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.15 + 0.4);
        osc.connect(gain).connect(ctx.destination);
        osc.start(now + i * 0.15);
        osc.stop(now + i * 0.15 + 0.5);
      });
    } else {
      // Descending two-note for cancellation
      const freqs = [440, 349.23]; // A4 → F4
      freqs.forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = "triangle";
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0, now + i * 0.15);
        gain.gain.linearRampToValueAtTime(0.12, now + i * 0.15 + 0.05);
        gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.15 + 0.4);
        osc.connect(gain).connect(ctx.destination);
        osc.start(now + i * 0.15);
        osc.stop(now + i * 0.15 + 0.5);
      });
    }

    // Auto-close context after sounds finish
    setTimeout(() => ctx.close(), 1500);
  } catch {
    /* AudioContext not available — silent fallback */
  }
}
